import { STORAGE, sessionStorageKeys } from 'config/storage-config';
import { useStateMachineContext } from 'machines/hooks/useStateMachineContext';
import { beforeUnloadHandler } from 'hooks/useBeforeUnload';

export const useNavigateToExternalURL = () => {
  const { actor } = useStateMachineContext();

  return (url) => {
    window.onbeforeunload = null;
    window.removeEventListener('beforeunload', beforeUnloadHandler);
    window.addEventListener('beforeunload', () => {
      actor.stop();
      STORAGE.removeItem(sessionStorageKeys.PARTNER_PATH);
    });

    window.location.assign(url);
  };
};
